import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import LoanWizardLauncher from "@/components/LoanWizardLauncher";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import { SiteContentProvider } from "@/contexts/SiteContent";

export default function PublicLayout() {
  return (
    <SiteContentProvider>
      <div className="min-h-screen flex flex-col bg-[var(--tara-bg)]">
        <Navbar />
        <main className="flex-1"><Outlet /></main>
        <Footer />
        <LoanWizardLauncher />
        <FloatingWhatsApp />
      </div>
    </SiteContentProvider>
  );
}
